import { OrderStatus } from "../types";

export const FREQUENCY_OPTIONS = [
  { label: "Monthly", value: "MONTHLY" },
  { label: "Weekly", value: "WEEKLY" },
  { label: "Daily", value: "DAILY" },
  // We might need to add these options in the future
  // { label: "Quarterly", value: "QUARTERLY" },
  // { label: "Semi-Annually", value: "SEMI-ANNUALLY" },
  // { label: "Annually", value: "ANNUALLY" },
];

export const WEEK_DAYS = [
  { label: "Mon", value: 1 },
  { label: "Tue", value: 2 },
  { label: "Wed", value: 3 },
  { label: "Thu", value: 4 },
  { label: "Fri", value: 5 },
];

export enum RedemptionBy {
  UNITS = "units",
  AMOUNT = "amount",
}

export const REMDEMPTION_BY_OPTIONS = [
  {
    label: "Units",
    value: RedemptionBy.UNITS,
  },
  {
    label: "Amount",
    value: RedemptionBy.AMOUNT,
  },
];

export enum TransactionOrderType {
  "PURCHASE" = "PURCHASE",
  "REDEMPTION" = "REDEMPTION",
  "SWITCH" = "SWITCH",
  "XSIP" = "XSIP",
  "SWP" = "SWP",
  "STP" = "STP",
}

export enum TransactionType {
  ONE_TIME = "One time",
  SIP = "SIP",
  REDEMPTION = "Redemption",
  STP = "STP",
  SWP = "SWP",
  SWITCH = "Switch",
}

export const CANCEL_REASONS = [
  {
    label: "Non availability of Funds",
    value: "01",
  },
  {
    label: "Scheme not performing",
    value: "02",
  },
  {
    label: "Goal Achieved",
    value: "07",
  },
  {
    label: "Service issue",
    value: "03",
  },
  {
    label: "Other",
    value: "13",
  },
];

export const SUBMITTED_ORDER_TYPE_LABELS = {
  PURCHASE: "Purchase",
  "SIP INSTALLMENT": "SIP Installment",
  REDEMPTION: "Redemption",
  SWITCH_OUT: "Switch Out",
  SWITCH_IN: "Switch In",
  "SWP INSTALLMENT": "SWP Installment",
  "STP INSTALLMENT": "STP Installment",
};

export const TRANSACTION_ORDER_TYPE_LABELS = {
  PURCHASE: "Purchase",
  REDEMPTION: "Redemption",
  SWITCH: "Switch",
  XSIP: "SIP",
  SWP: "SWP",
  STP: "STP",
};

export const ORDER_STATUS_FILTER_MAP = {
  "Under processing": "under_processing",
  "Payment pending": "payment_pending",
  "Payment completed": "payment_completed",
  Failed: "failed",
  "Order completed": "completed",
} as Record<OrderStatus, string>;

export enum StepupFrequency {
  YEARLY = 12,
  HALFYEARLY = 6,
}

export const STEP_UP_FREQUENCY_OPTIONS: {
  label: string;
  value: StepupFrequency;
}[] = [
  { label: "Every 6 months", value: 6 },
  { label: "Every 12 months", value: 12 },
];
